import { useGameStore } from '../store/gameStore';
import { useGameSignalR } from '../hooks/useSignalR';
import { useTeamStore } from '../store/teamStore';
import { QuestionCard } from './QuestionCard';
import { Scoreboard } from './Scoreboard';
import { GameResults } from './GameResults';
import { LoadingSpinner } from '@/components/shared/LoadingSpinner';

export const GameSession = () => {
  const { gameStatus, currentQuestion, currentQuestionIndex, totalQuestions } = useGameStore();
  const { submitAnswer, useLifeline } = useGameSignalR();
  const { team1, team2 } = useTeamStore();

  if (gameStatus === 'Ended') {
    return <GameResults />;
  }

  if (!currentQuestion) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-primary via-accent-greenLight/10 to-primary">
        <div className="text-center space-y-4">
          <LoadingSpinner size="lg" />
          <p className="text-xl text-gray-700">جاري تحميل السؤال...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary via-accent-greenLight/10 to-primary p-4">
      <div className="max-w-6xl mx-auto space-y-6">
        {/* Progress Bar */}
        <div className="bg-white rounded-lg p-4 shadow-lg">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm font-medium text-gray-700">
              السؤال {currentQuestionIndex + 1} من {totalQuestions}
            </span>
            <span className="text-sm font-medium text-gray-700">
              {Math.round(((currentQuestionIndex + 1) / totalQuestions) * 100)}%
            </span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-3">
            <div
              className="bg-secondary h-3 rounded-full transition-all duration-300"
              style={{ width: `${((currentQuestionIndex + 1) / totalQuestions) * 100}%` }}
            />
          </div>
        </div>

        {/* Teams Display */}
        {(team1 || team2) && (
          <div className="grid md:grid-cols-2 gap-4">
            {team1 && (
              <div className="bg-red-50 border-2 border-red-200 rounded-lg p-4">
                <h3 className="font-bold text-red-600 mb-2">{team1.name}</h3>
                <p className="text-sm text-gray-600">{team1.members.length} عضو</p>
              </div>
            )}
            {team2 && (
              <div className="bg-green-50 border-2 border-green-200 rounded-lg p-4">
                <h3 className="font-bold text-green-600 mb-2">{team2.name}</h3>
                <p className="text-sm text-gray-600">{team2.members.length} عضو</p>
              </div>
            )}
          </div>
        )}

        <div className="grid lg:grid-cols-3 gap-6">
          {/* Scoreboard Sidebar */}
          <div className="lg:col-span-1">
            <Scoreboard />
          </div>

          {/* Question Card */}
          <div className="lg:col-span-2">
            <QuestionCard
              question={currentQuestion}
              onSubmit={submitAnswer}
              onUseLifeline={useLifeline}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
